import { render, staticRenderFns } from "./ParticipantFicha.vue?vue&type=template&id=ec41c5f8&"
import script from "./ParticipantFicha.vue?vue&type=script&lang=js&"
export * from "./ParticipantFicha.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports